import { useMemo } from "react";

import { formatCalendarDateForInput, formatDateForPanelDisplay } from "../../../Utils/helper";

const HistoryTab = ({ history = [] }) => {
  const rows = useMemo(() => {
    const events = [];

    history.forEach((item) => {
      // First Day
      if (item.start_date) {
        events.push({
          id: `start-${item.id}`,
          employerId: item.employer?.id,
          employer: item.employer?.employment_contact,
          date: item.start_date,
          label: "First Day",
        });
      }

      // Time Missed Periods
      item.time_missed_periods?.forEach((period) => {
        if (period.time_missed_start && period.time_missed_end) {
          const startDate = formatCalendarDateForInput(period.time_missed_start);
          const endDate = formatCalendarDateForInput(period.time_missed_end);
          if (!startDate || !endDate) return;

          const [startYear, startMonth, startDay] = startDate.split("-").map(Number);
          const [endYear, endMonth, endDay] = endDate.split("-").map(Number);
          const current = new Date(Date.UTC(startYear, startMonth - 1, startDay));
          const end = new Date(Date.UTC(endYear, endMonth - 1, endDay));

          while (current <= end) {
            const date = current.toISOString().slice(0, 10);
            events.push({
              id: `missed-${period.id}-${date}`,
              employerId: item.employer?.id,
              employer: item.employer?.employment_contact,
              date,
              label: "Day Work Missed",
            });

            current.setUTCDate(current.getUTCDate() + 1);
          }
        }
      });

      // Last Day
      if (item.end_date) {
        events.push({
          id: `end-${item.id}`,
          employerId: item.employer?.id,
          employer: item.employer?.employment_contact,
          date: item.end_date,
          label: "Last Day",
        });
      }
    });

    return events;
  }, [history]);

  return (
    <div
      style={{
        height: "560px",
        overflowY: "auto",
        width: "100%",
        scrollbarWidth: "none",
      }}
      className="invisible-scrollbar m-b-5"
    >
      <table
        className="table table-borderless table-striped table-treatment has-specialty-icon has-height-25"
        style={{ width: "100%" }}
      >
        <thead style={{ position: "sticky", top: 0 }}>
          <tr id="tb-header">
            <th
              style={{
                width: "25px",
                minWidth: "25px",
                maxWidth: "25px",
              }}
            />
            <th className="td-autosize text-center color-grey-2">Employer</th>
            <th />
            <th className="td-autosize text-center color-grey-2">Date</th>
            <th />
            <th className="td-autosize text-center color-grey-2">Type</th>
            <th
              style={{
                width: "10px",
                minWidth: "10px",
                maxWidth: "10px",
              }}
            />
          </tr>
        </thead>

        <tbody>
          {rows.map((row, idx) => (
            <tr className="height-25" key={row.id}>
              <td
                style={{
                  color: "var(--primary-25)",
                  fontWeight: "600",
                }}
              >
                {idx + 1}
              </td>
              <td
                style={{
                  fontWeight: "600",
                }}
                className="text-start"
              >
                {row.employer?.name}
              </td>
              <td />
              <td
                style={{
                  fontWeight: "600",
                }}
                className="text-end"
              >
                {formatDateForPanelDisplay(row.date)}
              </td>
              <td />
              <td
                style={{
                  fontWeight: "600",
                }}
                className="text-start"
              >
                {row.label}
              </td>
              <td />
            </tr>
          ))}

          {Array.from({ length: Math.max(0, 21 - rows.length) }).map((_, i) => (
            <tr key={`fake-${i}`} className="fake-rows-new-provider height-25">
              <td colSpan={6} />
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default HistoryTab;
